import type { FeatureManifest } from '../registry.js';

/** SY-02.1/2.2: age check (OVL-07), consent (OVL-08) and the parental gate. */
export default {
  id: 'privacy',
  provides: ['privacyGate', 'consent', 'parentalGate', 'parentLink'],
  links: ['parentConsent', 'parentRevoke'],
  load: () => import('./index.js'),
} satisfies FeatureManifest;
